export default function dictFilter() {
    return function (input, param) {
        if (!param || !param.length) return input
        if (input === '' && param[0].enumTypeCode === 'ovat_tax_rate') return '多税率'
        if (input === null || input === undefined) {
            return input
        }
        // var enumType = $filter('filter')(param,{'enumCode':input});
        const enumType = param.filter((item) => encodeURIComponent(item.enumCode) === encodeURIComponent(input))
        if (enumType.length > 0) {
            return enumType[0].enumName
        }
        return input
    }
}



// WEBPACK FOOTER //
// ./src/common/services/dictFilter.js